import { Observable } from 'rxjs';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';

export abstract class  FxDetailService {
    constructor(public http: FxDapHttpClient) {
     }
}
